var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gmap-map',{ref:"mymap",staticClass:"map map--detail",attrs:{"center":_vm.center,"options":{
    controlSize: 25,
    scrollwheel: _vm.isMapInitialized,
    maxZoom: _vm.setZoomForFallbackLocation()
  }}},[_vm._l((_vm.stopLocations),function(stopLocation,index){return _c('gmap-custom-marker',{key:stopLocation.id,attrs:{"marker":stopLocation},nativeOn:{"click":function($event){return _vm.showInfoWindow(stopLocation)}}},[_c('div',{staticClass:"map-marker"},[_c('span',{staticClass:"map-marker-label"},[_vm._v(_vm._s(_vm.getLabel(index)))]),_c('img',{staticClass:"map-marker-image",attrs:{"src":require("@/assets/svgs/google-marker.svg")}})])])}),_c('gmap-info-window',{attrs:{"options":{
      maxWidth: 300,
      pixelOffset: {
        width: 0,
        height: -15 // Moves the info window up so it doesn't hide the marker
      }
    },"position":_vm.infoWindow.position,"opened":_vm.infoWindow.open},on:{"closeclick":function($event){_vm.infoWindow.open = false}}},[_c('div',[_vm._v(_vm._s(_vm.infoWindow.template))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }